(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suave-comparison-infinite"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT = '[data-suave-comparison-infinite]';
  var currentLanguage = 'es';
  var escBound = false;
  var MOBILE_MAX = 900;
  var SWIPE_THRESHOLD = 40;

  function siteLanguage() {
    if (window.SuaveLocale && typeof window.SuaveLocale.getCurrentLocaleCode === 'function') {
      return window.SuaveLocale.getCurrentLocaleCode();
    }
    if (window.SuaveLocale && typeof window.SuaveLocale.isSiteSpanish === 'function') {
      return window.SuaveLocale.isSiteSpanish() ? 'es' : 'en';
    }
    var rootEl = document.documentElement;
    var dataLocale = rootEl && rootEl.getAttribute('data-suave-locale');
    if (dataLocale === 'es' || dataLocale === 'en') return dataLocale;
    var path = window.location.pathname || '';
    if (path === '/es' || path.indexOf('/es/') === 0) return 'es';
    if (path === '/en' || path.indexOf('/en/') === 0) return 'en';
    var htmlLang = (rootEl && rootEl.getAttribute('lang')) || '';
    if (String(htmlLang).toLowerCase().indexOf('es') === 0) return 'es';
    return 'en';
  }

  function cmpLabels(root) {
    return {
      closed: {
        es: root.getAttribute('data-cmp-closed-es') || 'Componentes',
        en: root.getAttribute('data-cmp-closed-en') || 'Components'
      },
      open: {
        es: root.getAttribute('data-cmp-open-es') || 'Cerrar',
        en: root.getAttribute('data-cmp-open-en') || 'Close'
      }
    };
  }

  function updateToggle(btn, lang) {
    var root = btn.closest(ROOT);
    if (!root) return;
    var labels = cmpLabels(root);
    var isOpen = btn.getAttribute('aria-pressed') === 'true';
    var name = btn.getAttribute('data-model-name') || '';
    var labelEl = btn.querySelector('.suave-component-label');
    var iconEl = btn.querySelector('.suave-component-icon');
    var card = btn.closest('.suave-card');
    var image = card ? card.querySelector('.suave-product-image') : null;
    btn.classList.toggle('is-active', isOpen);
    if (labelEl) {
      var closedEs = labelEl.getAttribute('data-es') || labels.closed.es;
      var closedEn = labelEl.getAttribute('data-en') || labels.closed.en;
      var openEs = labelEl.getAttribute('data-open-es') || labels.open.es;
      var openEn = labelEl.getAttribute('data-open-en') || labels.open.en;
      labelEl.textContent = isOpen ? (lang === 'es' ? openEs : openEn) : (lang === 'es' ? closedEs : closedEn);
    }
    if (iconEl) iconEl.textContent = isOpen ? '\u00D7' : '+';
    btn.setAttribute(
      'aria-label',
      lang === 'es'
        ? (isOpen ? ('Cerrar la vista de componentes de ' + name) : ('Ver la vista de componentes de ' + name))
        : (isOpen ? ('Close the exploded component view for ' + name) : ('View the exploded components of ' + name))
    );
    if (image && isOpen) {
      image.alt = lang === 'es' ? ('Vista de componentes de ' + name) : (name + ' exploded component view');
    }
  }

  function pickLocalized(el, lang) {
    var preferred = el.getAttribute('data-' + lang);
    if (preferred != null && String(preferred).trim() !== '') return preferred;
    var fallback = el.getAttribute('data-' + (lang === 'es' ? 'en' : 'es'));
    if (fallback != null && String(fallback).trim() !== '') return fallback;
    return preferred != null ? preferred : (fallback != null ? fallback : null);
  }

  function applyToRoot(root, lang) {
    root.setAttribute('lang', lang);
    var nodes = root.querySelectorAll('[data-es][data-en]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList && el.classList.contains('suave-component-label')) continue;
      var val = pickLocalized(el, lang);
      if (val !== null) el.textContent = val;
    }
    var chars = root.querySelectorAll('.suave-characteristic');
    for (var j = 0; j < chars.length; j++) {
      var tip = chars[j].getAttribute(lang === 'en' ? 'data-tooltip-en' : 'data-tooltip-es');
      if (!tip || String(tip).trim() === '') tip = chars[j].getAttribute(lang === 'en' ? 'data-tooltip-es' : 'data-tooltip-en');
      var nm = pickLocalized(chars[j], lang) || chars[j].textContent;
      if (tip) {
        chars[j].setAttribute('data-tooltip', tip);
        chars[j].setAttribute('aria-label', nm + ': ' + tip);
      }
    }
    var toggles = root.querySelectorAll('[data-component-toggle]');
    for (var k = 0; k < toggles.length; k++) updateToggle(toggles[k], lang);
    var langBtn = root.querySelector('[data-lang-toggle]');
    if (langBtn) {
      langBtn.setAttribute('aria-label', lang === 'es' ? 'Switch language to English' : 'Cambiar idioma a espa\u00F1ol');
      var nextLabel = langBtn.getAttribute(lang === 'es' ? 'data-es' : 'data-en');
      if (nextLabel) langBtn.textContent = nextLabel;
    }
  }

  function applyLanguage(lang) {
    currentLanguage = lang === 'en' ? 'en' : 'es';
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) applyToRoot(roots[i], currentLanguage);
  }

  function switchSiteLanguage(next) {
    if (window.SuaveLocale && typeof window.SuaveLocale.switchLocale === 'function') {
      window.SuaveLocale.switchLocale(next);
      return;
    }
    applyLanguage(next);
  }

  function restoreImage(btn) {
    var card = btn.closest('.suave-card');
    var image = card ? card.querySelector('.suave-product-image') : null;
    if (!image) return;
    image.src = image.getAttribute('data-original-src') || image.src;
    image.alt = image.getAttribute('data-original-alt') || image.alt;
    btn.setAttribute('aria-pressed', 'false');
    updateToggle(btn, currentLanguage);
  }

  function toggleComponent(btn, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var root = btn.closest(ROOT);
    var card = btn.closest('.suave-card');
    var image = card ? card.querySelector('.suave-product-image') : null;
    var src = btn.getAttribute('data-component-image');
    var isOpen = btn.getAttribute('aria-pressed') === 'true';
    if (!image || !src) return;
    if (isOpen) {
      restoreImage(btn);
      if (root && root._suaveInf) root._suaveInf.setPaused(false);
      return;
    }
    image.src = src;
    btn.setAttribute('aria-pressed', 'true');
    updateToggle(btn, currentLanguage);
    if (root && root._suaveInf) root._suaveInf.setPaused(true);
  }

  function initInfiniteSlider(root) {
    var viewport = root.querySelector('[data-suave-infinite-viewport]');
    var track = root.querySelector('[data-suave-infinite-track]');
    var prevBtn = root.querySelector('[data-suave-inf-prev]');
    var nextBtn = root.querySelector('[data-suave-inf-next]');
    var dotsWrap = root.querySelector('[data-suave-inf-dots]');
    if (!viewport || !track) return null;

    var wantDesktopSlider = root.getAttribute('data-desktop-slider') === 'true';
    var perDesktop = parseInt(root.getAttribute('data-per-view-desktop') || '3', 10) || 3;
    var perMobile = parseInt(root.getAttribute('data-per-view-mobile') || '1', 10) || 1;
    var auto = root.getAttribute('data-auto-slide') === 'true';
    var interval = parseInt(root.getAttribute('data-auto-slide-interval') || '4000', 10) || 4000;
    var wantArrows = root.getAttribute('data-show-arrows') === 'true';
    var wantDots = root.getAttribute('data-show-dots') === 'true';
    var pauseHover = root.classList.contains('suave-comparison--pause-hover');

    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-suave-inf-slide]:not([data-clone])'));
    if (!originals.length) return null;

    // Remove previous clones
    Array.prototype.slice.call(track.querySelectorAll('[data-clone]')).forEach(function (n) { n.parentNode.removeChild(n); });

    var index = 0;
    var timer = null;
    var gap = 20;
    var perView = perDesktop;
    var slideW = 0;
    var canSlide = false;
    var drag = null;
    var paused = false;
    var suppressClick = false;

    function isMobile() { return window.innerWidth <= MOBILE_MAX; }
    function currentPerView() { return isMobile() ? perMobile : perDesktop; }
    function shouldSlide() {
      if (isMobile()) return originals.length > currentPerView();
      return wantDesktopSlider && originals.length > currentPerView();
    }
    function isInteractiveTarget(el) {
      return !!(el && el.closest && el.closest('a, button, input, textarea, select, label, [data-component-toggle]'));
    }

    function setTransform(px, animate) {
      track.classList.toggle('is-dragging', animate === false);
      track.style.transform = 'translateX(' + (-px) + 'px)';
    }

    function pageWidth() { return perView * (slideW + gap); }

    var cloneCount = 0;

    function syncClones() {
      Array.prototype.slice.call(track.querySelectorAll('[data-clone]')).forEach(function (n) { n.parentNode.removeChild(n); });
      cloneCount = 0;
      if (!canSlide) return;
      cloneCount = Math.min(perView, originals.length);
      for (var i = 0; i < cloneCount; i++) {
        var tail = originals[i % originals.length].cloneNode(true);
        tail.setAttribute('data-clone', 'tail');
        tail.setAttribute('aria-hidden', 'true');
        track.appendChild(tail);
      }
      for (var k = cloneCount - 1; k >= 0; k--) {
        var src = originals[(originals.length - cloneCount + k + originals.length) % originals.length];
        var head = src.cloneNode(true);
        head.setAttribute('data-clone', 'head');
        head.setAttribute('aria-hidden', 'true');
        track.insertBefore(head, track.firstChild);
      }
    }

    function normalizedIndex() {
      var n = originals.length;
      if (!n) return 0;
      return ((index % n) + n) % n;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (!wantDots || !canSlide || originals.length < 2) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      var active = normalizedIndex();
      for (var i = 0; i < originals.length; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'suave-infinite-dot' + (i === active ? ' is-active' : '');
        btn.setAttribute('data-suave-inf-dot', '');
        btn.setAttribute('data-index', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === active) btn.setAttribute('aria-current', 'true');
        btn.addEventListener('click', function (ev) {
          goTo(parseInt(ev.currentTarget.getAttribute('data-index') || '0', 10) || 0);
        });
        dotsWrap.appendChild(btn);
      }
    }

    function updateDots() {
      if (!dotsWrap || dotsWrap.hidden) return;
      var active = normalizedIndex();
      var dots = dotsWrap.querySelectorAll('[data-suave-inf-dot]');
      Array.prototype.forEach.call(dots, function (dot, i) {
        var on = i === active;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function layout() {
      perView = currentPerView();
      gap = parseFloat(getComputedStyle(track).gap) || 20;
      canSlide = shouldSlide();
      root.classList.toggle('suave-comparison--slider-active', canSlide);

      var vw = viewport.offsetWidth;
      slideW = (vw - gap * Math.max(0, perView - 1)) / perView;

      syncClones();

      if (canSlide) {
        var allSlides = track.querySelectorAll('[data-suave-inf-slide]');
        Array.prototype.forEach.call(allSlides, function (slide) {
          slide.style.flex = '0 0 ' + slideW + 'px';
          slide.style.width = slideW + 'px';
          slide.style.maxWidth = slideW + 'px';
        });
        index = ((index % originals.length) + originals.length) % originals.length;
        setTransform((index + cloneCount) * (slideW + gap), true);
      } else {
        index = 0;
        originals.forEach(function (slide) {
          slide.style.flex = '';
          slide.style.width = '';
          slide.style.maxWidth = '';
        });
        track.style.transform = '';
        track.classList.remove('is-dragging');
      }

      if (prevBtn) prevBtn.hidden = !(wantArrows && canSlide);
      if (nextBtn) nextBtn.hidden = !(wantArrows && canSlide);
      buildDots();
      start();
    }

    function goTo(next, instant) {
      if (!canSlide) return;
      index = next;
      var offsetIndex = index + cloneCount;
      setTransform(offsetIndex * (slideW + gap), !instant);
      updateDots();

      window.clearTimeout(goTo._t);
      goTo._t = window.setTimeout(function () {
        if (index < 0) {
          index = originals.length + index;
          setTransform((index + cloneCount) * (slideW + gap), false);
        } else if (index >= originals.length) {
          index = index - originals.length;
          setTransform((index + cloneCount) * (slideW + gap), false);
        }
        updateDots();
      }, instant ? 0 : 460);
      if (!instant) start();
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!auto || !canSlide || paused || drag) return;
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }

    function setPaused(v) {
      paused = !!v;
      if (paused) stop();
      else start();
    }

    function pointerPos(e) {
      if (e.touches && e.touches.length) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      if (e.changedTouches && e.changedTouches.length) return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      return { x: e.clientX, y: e.clientY };
    }

    function onPointerDown(e) {
      if (!canSlide) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Let links / buttons navigate or toggle — don't start a drag on them
      if (isInteractiveTarget(e.target)) return;
      var pos = pointerPos(e);
      suppressClick = false;
      drag = {
        startX: pos.x,
        startY: pos.y,
        base: (index + cloneCount) * (slideW + gap),
        locked: null,
        moved: false
      };
      stop();
      setTransform(drag.base, false);
      if (viewport.setPointerCapture && e.pointerId != null) {
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }

    function onPointerMove(e) {
      if (!drag) return;
      var pos = pointerPos(e);
      var dx = pos.x - drag.startX;
      var dy = pos.y - drag.startY;
      if (drag.locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        drag.locked = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      }
      if (drag.locked === 'y') {
        drag = null;
        goTo(index, true);
        start();
        return;
      }
      if (drag.locked !== 'x') return;
      e.preventDefault();
      drag.moved = true;
      suppressClick = true;
      setTransform(drag.base - dx, false);
    }

    function onPointerUp(e) {
      if (!drag) return;
      var pos = pointerPos(e);
      var dx = pos.x - drag.startX;
      var wasSwipe = drag.moved && drag.locked === 'x' && Math.abs(dx) >= SWIPE_THRESHOLD;
      var wasTap = !drag.moved;
      drag = null;
      if (viewport.releasePointerCapture && e.pointerId != null) {
        try { viewport.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      if (wasSwipe) {
        goTo(index + (dx < 0 ? 1 : -1));
      } else if (wasTap) {
        // Pure click — snap back without blocking link navigation
        setTransform((index + cloneCount) * (slideW + gap), true);
        start();
      } else {
        goTo(index);
      }
    }

    function onViewportClick(e) {
      if (!suppressClick) return;
      suppressClick = false;
      if (isInteractiveTarget(e.target)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    if (prevBtn) prevBtn.onclick = function () { goTo(index - 1); };
    if (nextBtn) nextBtn.onclick = function () { goTo(index + 1); };

    if (!viewport._suaveBound) {
      viewport._suaveBound = true;
      if (window.PointerEvent) {
        viewport.addEventListener('pointerdown', onPointerDown);
        viewport.addEventListener('pointermove', onPointerMove);
        viewport.addEventListener('pointerup', onPointerUp);
        viewport.addEventListener('pointercancel', onPointerUp);
      } else {
        viewport.addEventListener('touchstart', onPointerDown, { passive: true });
        viewport.addEventListener('touchmove', onPointerMove, { passive: false });
        viewport.addEventListener('touchend', onPointerUp);
      }
      viewport.addEventListener('click', onViewportClick, true);
      if (pauseHover) {
        root.addEventListener('mouseenter', function () { setPaused(true); });
        root.addEventListener('mouseleave', function () { if (!drag) setPaused(false); });
      }
    }

    layout();
    return { layout: layout, setPaused: setPaused, goTo: goTo };
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest(ROOT);
    if (!root) return;
    var langBtn = t.closest('[data-lang-toggle]');
    if (langBtn && root.contains(langBtn)) {
      e.preventDefault();
      switchSiteLanguage(currentLanguage === 'es' ? 'en' : 'es');
      return;
    }
    var cmpBtn = t.closest('[data-component-toggle]');
    if (cmpBtn && root.contains(cmpBtn)) toggleComponent(cmpBtn, e);
  }

  function onKeyDown(e) {
    if (e.key !== 'Escape') return;
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var open = roots[i].querySelectorAll('[data-component-toggle][aria-pressed="true"]');
      for (var j = 0; j < open.length; j++) {
        restoreImage(open[j]);
        if (roots[i]._suaveInf) roots[i]._suaveInf.setPaused(false);
      }
    }
  }

  function initRoot(root) {
    applyToRoot(root, currentLanguage);
    root._suaveInf = initInfiniteSlider(root);
  }

  function boot() {
    currentLanguage = siteLanguage();
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    document.addEventListener('click', onClick);
    if (!escBound) {
      escBound = true;
      document.addEventListener('keydown', onKeyDown);
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var rs = document.querySelectorAll(ROOT);
        for (var i = 0; i < rs.length; i++) {
          if (rs[i]._suaveInf) rs[i]._suaveInf.layout();
        }
      }, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector(ROOT) : null;
    if (root) initRoot(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suave-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT = '[data-suave-comparison]';
  var currentLanguage = 'es';
  var escBound = false;

  function siteLanguage() {
    if (window.SuaveLocale && typeof window.SuaveLocale.getCurrentLocaleCode === 'function') {
      return window.SuaveLocale.getCurrentLocaleCode();
    }
    if (window.SuaveLocale && typeof window.SuaveLocale.isSiteSpanish === 'function') {
      return window.SuaveLocale.isSiteSpanish() ? 'es' : 'en';
    }
    var rootEl = document.documentElement;
    var dataLocale = rootEl && rootEl.getAttribute('data-suave-locale');
    if (dataLocale === 'es' || dataLocale === 'en') return dataLocale;
    var path = window.location.pathname || '';
    if (path === '/es' || path.indexOf('/es/') === 0) return 'es';
    if (path === '/en' || path.indexOf('/en/') === 0) return 'en';
    var htmlLang = (rootEl && rootEl.getAttribute('lang')) || '';
    if (String(htmlLang).toLowerCase().indexOf('es') === 0) return 'es';
    return 'en';
  }

  function cmpLabels(root) {
    return {
      closed: {
        es: root.getAttribute('data-cmp-closed-es') || 'Componentes',
        en: root.getAttribute('data-cmp-closed-en') || 'Components'
      },
      open: {
        es: root.getAttribute('data-cmp-open-es') || 'Cerrar',
        en: root.getAttribute('data-cmp-open-en') || 'Close'
      }
    };
  }

  function updateToggle(btn, lang) {
    var root = btn.closest(ROOT);
    if (!root) return;
    var labels = cmpLabels(root);
    var isOpen = btn.getAttribute('aria-pressed') === 'true';
    var name = btn.getAttribute('data-model-name') || '';
    var labelEl = btn.querySelector('.suave-component-label');
    var iconEl = btn.querySelector('.suave-component-icon');
    var card = btn.closest('.suave-card');
    var image = card ? card.querySelector('.suave-product-image') : null;

    btn.classList.toggle('is-active', isOpen);

    if (labelEl) {
      var closedEs = labelEl.getAttribute('data-es') || labels.closed.es;
      var closedEn = labelEl.getAttribute('data-en') || labels.closed.en;
      var openEs = labelEl.getAttribute('data-open-es') || labels.open.es;
      var openEn = labelEl.getAttribute('data-open-en') || labels.open.en;
      labelEl.textContent = isOpen
        ? (lang === 'es' ? openEs : openEn)
        : (lang === 'es' ? closedEs : closedEn);
    }
    if (iconEl) {
      iconEl.textContent = isOpen ? '\u00D7' : '+';
    }
    btn.setAttribute(
      'aria-label',
      lang === 'es'
        ? (isOpen ? ('Cerrar la vista de componentes de ' + name) : ('Ver la vista de componentes de ' + name))
        : (isOpen ? ('Close the exploded component view for ' + name) : ('View the exploded components of ' + name))
    );
    if (image && isOpen) {
      image.alt = lang === 'es' ? ('Vista de componentes de ' + name) : (name + ' exploded component view');
    }
  }

  function pickLocalized(el, lang) {
    var preferred = el.getAttribute('data-' + lang);
    if (preferred != null && String(preferred).trim() !== '') return preferred;
    var fallback = el.getAttribute('data-' + (lang === 'es' ? 'en' : 'es'));
    if (fallback != null && String(fallback).trim() !== '') return fallback;
    return preferred != null ? preferred : (fallback != null ? fallback : null);
  }

  function applyToRoot(root, lang) {
    root.setAttribute('lang', lang);

    var nodes = root.querySelectorAll('[data-es][data-en]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList && el.classList.contains('suave-component-label')) continue;
      var val = pickLocalized(el, lang);
      if (val !== null) el.textContent = val;
    }

    var chars = root.querySelectorAll('.suave-characteristic');
    for (var j = 0; j < chars.length; j++) {
      var tip = chars[j].getAttribute(lang === 'en' ? 'data-tooltip-en' : 'data-tooltip-es');
      if (!tip || String(tip).trim() === '') {
        tip = chars[j].getAttribute(lang === 'en' ? 'data-tooltip-es' : 'data-tooltip-en');
      }
      var nm = pickLocalized(chars[j], lang) || chars[j].textContent;
      if (tip) {
        chars[j].setAttribute('data-tooltip', tip);
        chars[j].setAttribute('aria-label', nm + ': ' + tip);
      }
    }

    var toggles = root.querySelectorAll('[data-component-toggle]');
    for (var k = 0; k < toggles.length; k++) updateToggle(toggles[k], lang);

    var langBtn = root.querySelector('[data-lang-toggle]');
    if (langBtn) {
      langBtn.setAttribute('aria-label', lang === 'es' ? 'Switch language to English' : 'Cambiar idioma a espa\u00F1ol');
      var nextLabel = langBtn.getAttribute(lang === 'es' ? 'data-es' : 'data-en');
      if (nextLabel) langBtn.textContent = nextLabel;
    }
  }

  function applyLanguage(lang) {
    currentLanguage = lang === 'en' ? 'en' : 'es';
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) applyToRoot(roots[i], currentLanguage);
  }

  function switchSiteLanguage(next) {
    if (window.SuaveLocale && typeof window.SuaveLocale.switchLocale === 'function') {
      window.SuaveLocale.switchLocale(next);
      return;
    }
    applyLanguage(next);
  }

  function restoreImage(btn) {
    var card = btn.closest('.suave-card');
    var image = card ? card.querySelector('.suave-product-image') : null;
    if (!image) return;
    image.src = image.getAttribute('data-original-src') || image.src;
    image.alt = image.getAttribute('data-original-alt') || image.alt;
    btn.setAttribute('aria-pressed', 'false');
    updateToggle(btn, currentLanguage);
  }

  function toggleComponent(btn, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var card = btn.closest('.suave-card');
    var image = card ? card.querySelector('.suave-product-image') : null;
    var src = btn.getAttribute('data-component-image');
    var isOpen = btn.getAttribute('aria-pressed') === 'true';
    if (!image || !src) return;
    if (isOpen) { restoreImage(btn); return; }
    image.src = src;
    btn.setAttribute('aria-pressed', 'true');
    updateToggle(btn, currentLanguage);
  }

  function switchTab(root, tabId) {
    var btns = root.querySelectorAll('[data-tab-btn]');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-tab-btn') === tabId;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    var panels = root.querySelectorAll('[data-tab-panel]');
    for (var j = 0; j < panels.length; j++) {
      var panel = panels[j];
      if (panel.getAttribute('data-tab-panel') === tabId) {
        panel.classList.remove('is-hidden');
        panel.setAttribute('aria-hidden', 'false');
        void panel.offsetWidth; // reflow so the fade-in animates
        panel.classList.remove('is-faded');
      } else {
        panel.classList.add('is-faded');
        panel.setAttribute('aria-hidden', 'true');
        (function (p) {
          window.setTimeout(function () {
            if (p.classList.contains('is-faded')) p.classList.add('is-hidden');
          }, 300);
        })(panel);
      }
    }
    window.setTimeout(function () {
      initMobileSliders(root);
    }, 50);
  }

  function isMobileSliderViewport() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function getSliderCards(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll('.suave-card'));
  }

  function getNearestCardIndex(grid, cards) {
    if (!cards.length) return 0;
    var left = grid.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var dist = Math.abs(cards[i].offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function scrollGridToIndex(grid, cards, index) {
    if (!cards.length) return;
    var i = Math.max(0, Math.min(cards.length - 1, index));
    var card = cards[i];
    var target = card.offsetLeft - Math.max(0, (grid.clientWidth - card.offsetWidth) / 2);
    grid.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    return i;
  }

  function updateSliderChrome(wrap, grid, index) {
    var cards = getSliderCards(grid);
    var prev = wrap.querySelector('[data-suave-grid-prev]');
    var next = wrap.querySelector('[data-suave-grid-next]');
    var dots = wrap.querySelector('[data-suave-grid-dots]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= cards.length - 1;
    if (dots) {
      var buttons = dots.querySelectorAll('.suave-grid-dot');
      for (var d = 0; d < buttons.length; d++) {
        buttons[d].classList.toggle('is-active', d === index);
      }
    }
  }

  function buildSliderDots(wrap, grid) {
    var dots = wrap.querySelector('[data-suave-grid-dots]');
    if (!dots) return;
    var cards = getSliderCards(grid);
    dots.innerHTML = '';
    if (cards.length < 2) {
      dots.setAttribute('hidden', '');
      return;
    }
    dots.removeAttribute('hidden');
    for (var i = 0; i < cards.length; i++) {
      (function (idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'suave-grid-dot' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to card ' + (idx + 1));
        btn.addEventListener('click', function () {
          scrollGridToIndex(grid, cards, idx);
          updateSliderChrome(wrap, grid, idx);
          restartAutoplay(wrap);
        });
        dots.appendChild(btn);
      })(i);
    }
  }

  function clearAutoplay(wrap) {
    if (wrap._suaveAutoplayTimer) {
      window.clearInterval(wrap._suaveAutoplayTimer);
      wrap._suaveAutoplayTimer = null;
    }
  }

  function restartAutoplay(wrap) {
    clearAutoplay(wrap);
    var root = wrap.closest(ROOT);
    if (!root || root.getAttribute('data-mobile-slider-autoplay') !== 'true') return;
    if (!isMobileSliderViewport()) return;
    var grid = wrap.querySelector('[data-suave-grid]');
    if (!grid || grid.classList.contains('is-hidden')) return;
    var speed = parseInt(root.getAttribute('data-mobile-slider-speed'), 10) || 4000;
    wrap._suaveAutoplayTimer = window.setInterval(function () {
      if (!isMobileSliderViewport()) {
        clearAutoplay(wrap);
        return;
      }
      var cards = getSliderCards(grid);
      if (cards.length < 2) return;
      var idx = getNearestCardIndex(grid, cards);
      var nextIdx = idx >= cards.length - 1 ? 0 : idx + 1;
      scrollGridToIndex(grid, cards, nextIdx);
      updateSliderChrome(wrap, grid, nextIdx);
    }, speed);
  }

  function initMobileSliderWrap(wrap, root) {
    if (!wrap || !root) return;
    if (root.getAttribute('data-mobile-slider') !== 'true') return;
    var grid = wrap.querySelector('[data-suave-grid]');
    if (!grid) return;

    if (wrap.getAttribute('data-slider-bound') !== 'true') {
      wrap.setAttribute('data-slider-bound', 'true');
      var prev = wrap.querySelector('[data-suave-grid-prev]');
      var next = wrap.querySelector('[data-suave-grid-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          var cards = getSliderCards(grid);
          var idx = getNearestCardIndex(grid, cards);
          var nextIdx = scrollGridToIndex(grid, cards, idx - 1);
          updateSliderChrome(wrap, grid, nextIdx);
          restartAutoplay(wrap);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var cards = getSliderCards(grid);
          var idx = getNearestCardIndex(grid, cards);
          var nextIdx = scrollGridToIndex(grid, cards, idx + 1);
          updateSliderChrome(wrap, grid, nextIdx);
          restartAutoplay(wrap);
        });
      }
      var scrollTimer = null;
      grid.addEventListener('scroll', function () {
        if (scrollTimer) window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var cards = getSliderCards(grid);
          updateSliderChrome(wrap, grid, getNearestCardIndex(grid, cards));
        }, 80);
      }, { passive: true });
      grid.addEventListener('pointerdown', function () {
        clearAutoplay(wrap);
      });
      grid.addEventListener('touchstart', function () {
        clearAutoplay(wrap);
      }, { passive: true });
    }

    buildSliderDots(wrap, grid);
    var cards = getSliderCards(grid);
    updateSliderChrome(wrap, grid, getNearestCardIndex(grid, cards));
    if (!grid.classList.contains('is-hidden')) {
      restartAutoplay(wrap);
    } else {
      clearAutoplay(wrap);
    }
  }

  function initMobileSliders(root) {
    if (!root || root.getAttribute('data-mobile-slider') !== 'true') return;
    var wraps = root.querySelectorAll('[data-suave-grid-wrap]');
    for (var i = 0; i < wraps.length; i++) {
      initMobileSliderWrap(wraps[i], root);
    }
  }

  function initRoot(root) {
    if (root.getAttribute('data-suave-ready') === 'true') return;
    root.setAttribute('data-suave-ready', 'true');

    var cards = root.querySelectorAll('.suave-card');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.addEventListener('click', function () {
          var grid = card.closest('.suave-grid');
          if (grid) {
            var siblings = grid.querySelectorAll('.suave-card');
            for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-active');
          }
          card.classList.add('is-active');
        });
      })(cards[i]);
    }

    var toggles = root.querySelectorAll('[data-component-toggle]');
    for (var t = 0; t < toggles.length; t++) {
      (function (btn) {
        btn.addEventListener('click', function (e) { toggleComponent(btn, e); });
      })(toggles[t]);
    }

    var tabBtns = root.querySelectorAll('[data-tab-btn]');
    for (var b = 0; b < tabBtns.length; b++) {
      (function (btn) {
        btn.addEventListener('click', function () { switchTab(root, btn.getAttribute('data-tab-btn')); });
      })(tabBtns[b]);
    }

    var langBtn = root.querySelector('[data-lang-toggle]');
    if (langBtn) {
      langBtn.addEventListener('click', function () {
        switchSiteLanguage(currentLanguage === 'es' ? 'en' : 'es');
      });
    }

    applyToRoot(root, currentLanguage);
    initMobileSliders(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  function bindEscape() {
    if (escBound) return;
    escBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      var open = document.querySelectorAll('[data-component-toggle][aria-pressed="true"]');
      for (var i = 0; i < open.length; i++) restoreImage(open[i]);
    });
  }

  function syncFromSiteLanguage() {
    applyLanguage(siteLanguage());
  }

  function boot() {
    currentLanguage = siteLanguage();
    bindEscape();
    initAll(document);
    applyLanguage(currentLanguage);
    var roots = document.querySelectorAll(ROOT);
    for (var r = 0; r < roots.length; r++) initMobileSliders(roots[r]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init a section that was just added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    currentLanguage = siteLanguage();
    initAll(e.target);
    applyLanguage(currentLanguage);
    var loadedRoot = e.target && e.target.querySelector ? e.target.querySelector(ROOT) : null;
    if (loadedRoot) initMobileSliders(loadedRoot);
    else if (e.target && e.target.matches && e.target.matches(ROOT)) initMobileSliders(e.target);
  });

  // Theme editor: selecting a card jumps to the collection tab that holds it.
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.suave-card') : null;
    if (!card) return;
    var panel = card.closest('[data-tab-panel]');
    var root = card.closest(ROOT);
    if (panel && root) switchTab(root, panel.getAttribute('data-tab-panel'));
  });

  // Keep in sync with site Español / English picker (SuaveLocale)
  window.addEventListener('pageshow', syncFromSiteLanguage);
  document.addEventListener('suave:localechange', function (e) {
    var code = e && e.detail && e.detail.code;
    applyLanguage(code === 'en' ? 'en' : code === 'es' ? 'es' : siteLanguage());
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var roots = document.querySelectorAll(ROOT);
      for (var i = 0; i < roots.length; i++) initMobileSliders(roots[i]);
    }, 150);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
